import React from 'react';
import { Link } from 'react-router-dom';
import '../css/featureGate.css';

/**
 * Hiển thị khi người cao tuổi chưa có gói / chưa liên kết — thay cho lỗi API thô.
 */
export default function MembershipRequiredView({
  compact = false,
  reason = 'membership',
  subtitle,
}) {
  const isNotLinked = reason === 'not_linked';

  const title = isNotLinked
    ? 'Chưa liên kết gia đình'
    : 'Cần gói TamCare Pro';

  const message = subtitle || (isNotLinked
    ? 'Vui lòng liên kết người cao tuổi và người thân bằng mã liên kết trước khi sử dụng.'
    : 'Tính năng này thuộc gói Pro (119.000đ/tháng). Người thân vui lòng mua gói cho người cao tuổi để mở khóa.');

  const primaryLink = isNotLinked ? '/my-relatives' : '/membership';
  const primaryLabel = isNotLinked ? 'Liên kết ngay' : 'Nâng cấp Pro';

  return (
    <div className={`tamcare-feature-lock ${compact ? 'tamcare-feature-lock--compact' : ''}`}>
      <div className="tamcare-feature-lock__icon">
        <i className="fa-solid fa-lock" />
      </div>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="tamcare-feature-lock__actions">
        <Link to={primaryLink} className="tamcare-feature-lock__btn tamcare-feature-lock__btn--primary">
          {primaryLabel}
        </Link>
        {!isNotLinked && (
          <Link to="/my-relatives" className="tamcare-feature-lock__btn tamcare-feature-lock__btn--ghost">
            Quản lý gia đình
          </Link>
        )}
      </div>
    </div>
  );
}

export function MembershipRequiredPage({ children, compact }) {
  return (
    <div className="container" style={{ padding: compact ? '24px' : '48px 24px' }}>
      {children}
    </div>
  );
}
